import { useMemo } from 'react';
import { TrainingAnswers } from '@common/model/client/training/types';
import { useDispatch } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { ITrainingApiProvider } from '../lib';
import { clientTrainingApi } from './core';

export const useTrainingApiProvider = (): ITrainingApiProvider => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  return useMemo(
    () => ({
      start() {
        return dispatch(clientTrainingApi.endpoints.startTraining.initiate()).unwrap();
      },
      finish(answers: TrainingAnswers): Promise<void> {
        return dispatch(clientTrainingApi.endpoints.finishTraining.initiate({ answers })).unwrap();
      },
    }),
    [dispatch],
  );
};
